import React, { Component } from 'react';
import update from 'react-addons-update';
import 'whatwg-fetch';
import { parse } from 'query-string';

class Row extends Component {
  render() {
    return (<li data-pct={this.props.score + '%'}
            className={this.props.unique ? "unique" : ""}>
              {this.props.word}
              <span> {this.props.score}%</span>
            </li>);
  }
}

Row.propTypes = {
  word: React.PropTypes.string.isRequired,
  score: React.PropTypes.number.isRequired,
  unique: React.PropTypes.bool.isRequired
};

const PUBS = {
  "left" : {
    title: "Left",
    pubs: ["The Nation", "Huffington Post"]
  },
  "right": {
    title: "Right",
    pubs: ["The Daily Caller", "Breitbart"]
  },
  "beltway": {
    title: "Mainstream",
    pubs: ["The New York Times", "The Washington Post"]
  },
  "digerati": {
    title: "Digital",
    pubs: ["The Daily Beast", "Vox"]
  },
  "tabloids": {
    title: "Tabloids",
    pubs: ["New York Post", "New York Daily News"]
  },
  "propublica": {
    title: "ProPublica",
    pubs: []
  }
};

class Result extends Component {
  render() {
    let cur = this.props.current ? "bar-chart current" : "bar-chart";
    return (
        <div className={cur}>
          <header>
            <h3>{PUBS[this.props.publication].title}</h3>
            <p>
              {PUBS[this.props.publication].pubs.map((it) => (
                 <span key={it}>{it}</span>
              ))}
            </p>
          </header>
          <ol>
            {this.props.data.map((it) => (
              <Row key={`${it.word}-${it.score}`}
                   {...it}
                />
            ))}
            {this.props.data.length === 0 ?
              <li className="row">No results.</li> : ""}
          </ol>
        </div>
    );
  }
}

Result.propTypes = {
  data: React.PropTypes.arrayOf(
    React.PropTypes.shape({
      word: React.PropTypes.string,
      score: React.PropTypes.number,
      unique: React.PropTypes.bool
    })).isRequired,
  publication: React.PropTypes.string.isRequired,
  current: React.PropTypes.bool.isRequired
};

Result.defaultProps = {
  data: [],
  publication: "",
  current: false
};

const endpoint = process.env.NODE_ENV === "development" ?
      "http://jeff.propublica.local:5000/news-words" :
      "https://projects.propublica.org/news-words";

class Searcher extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.onInput = this.onInput.bind(this);
    this.onError = this.onError.bind(this);
    this.prev = this.prev.bind(this);
    this.next = this.next.bind(this);
    this.state = {
      searchValue: props.searchValue,
      results: props.results,
      index: props.index
    };
  }

  componentDidMount() {
    this.load(this.state.searchValue);
  }

  onError(e) {
    this.setState({
      error: "Could not load from the server. Please try again later: " + e
    });
  }

  load(query) {
    this.setState({ loading: true });
    Searcher.order.forEach(function(it) {
      fetch(`${endpoint}?word=${query}&publication=${it}`)
        .then((response) => {
          if (response.ok && response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw new Error("Server error, please try again later.");
          }
        })
        .then((response) => (response.json()))
        .then((data) => {
          let counter = {};
          let curr = update(this.state.results || {}, {$merge: data});
          Object.keys(curr).forEach(function(key) {
            curr[key].forEach(function(it){
              if(!counter[it.word]) {
                counter[it.word] = 1;
              } else {
                counter[it.word]++;
              }
            });
          });

          Object.keys(curr).forEach(function(key) {
            curr[key] = curr[key].map(function(it){
              it.unique = (counter[it.word] === 1);
              return it;
            });
          });

          if(history)
            history.replaceState({}, "", `?word=${query}`);
          // TODO: process uniques
          this.setState({
            searchValue: query,
            results: curr,
            error: false
          });
        }).catch((e) => this.onError(e));
    }.bind(this));
  }

  handleSubmit(e) {
    e.preventDefault();
    this.load(this.state.searchValue);
  }

  handleClick(e, q) {
    e.preventDefault();
    this.load(q);
  }

  onInput(e) {
    this.setState({ searchValue: e.target.value });
  }

  next(e) {
    e.preventDefault();
    this.setState({
      index: this.state.index + 1 < Searcher.order.length ?
        this.state.index + 1 : 0
    });
  }

  prev(e) {
    e.preventDefault();
    this.setState({
      index: this.state.index - 1 > -1 ?
        this.state.index - 1 : Searcher.order.length - 1
    });
  }

  render() {
    return (
        <figure id="ai-interactive" className="full promo">
          <h2>See What AI Learns</h2>
          <p>
            We’ve created this AI system using Google’s <a href="https://github.com/tensorflow/tensorflow/blob/master/tensorflow/models/embedding/word2vec_optimized.py">open source
            technology</a>, and trained it to produce synonyms based on what it
            learned from different news sources. We trained it on six different
            datasets, each composed of tens of thousands of articles published
            by the news outlets described below.
          </p>
          <p>
            The synonyms are ranked in descending order based on how closely the
            AI system thought it matched the word entered. Highlighted words are
            synonyms that are unique to a dataset.
          </p>
	  <div className="ai-search">
	    <h3>Pick one or enter a word:</h3>
	    <ul className="shortcuts">
              {['Trump', 'Clinton', 'man', 'woman', 'server'].map((query, idx) => (
                <li key={query}>
                  <a href="#"
                     className={this.state.searchValue === query ? "current" : ""}
                     onClick={(e) => (this.handleClick(e, query))}>
                    {query}
                  </a>
                </li>
              ))}
	    </ul>
            <form id="search" onSubmit={this.handleSubmit}>
              <input type="text"
                     value={this.state.searchValue}
                     onChange={this.onInput} />
              <input type="submit" value="Search" />
            </form>
          </div>
          <nav>
    	    <a className="next" href="#" onClick={this.next}>→</a>
    	    <a className="previous" href="#" onClick={this.prev}>←</a>
          </nav>
          {Searcher.order.map((it, idx) => (
             <Result key={it}
                     publication={it}
                     data={this.state.results[it]}
                     current={this.state.index === idx} />
          ))}
      </figure>
    );
  }
}

Searcher.propTypes = {
  searchValue: React.PropTypes.string,
  results: React.PropTypes.objectOf(
    React.PropTypes.arrayOf(React.PropTypes.string)
  ).isRequired,
  index: React.PropTypes.number.isRequired
};

Searcher.order = ['left', 'right', 'beltway', 'digerati',
                  'tabloids', 'propublica'];

Searcher.defaultProps = {
  searchValue: "Clinton",
  results: Searcher.order.reduce((memo, it) => {
    memo[it] = []; return memo;
  }, {}),
  index: 0
};

let q = parse(location.search);

class App extends Component {
  render() {
    return <Searcher searchValue={q.word ? q.word : "Trump"} />;
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/